import ReducerConstants from "../../config/ReduxConstant";

const INITIAL_STATE: Array<Object> = []

export interface IActionProps {
  type: string,
  payload: Array<object>
}

export const feedbackData = (state = INITIAL_STATE, action: IActionProps) => {
  switch (action.type) {
    case ReducerConstants.SET_FEEDBACK_DATA:
      return action.payload || []
    default:
      return state
  }
}
